import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  RadialLinearScale,
  LinearScale,
  LineElement,
  LineController,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Bar } from 'react-chartjs-2';
import {floatFormatter} from '../Common/util';
import { chart_options_bar, chart_options_bar_y } from '../Common/options';

ChartJS.register(
  CategoryScale,
  RadialLinearScale,
  LinearScale,
  LineElement,
  LineController,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
);


export function Chart01({dataList, sumData}) {

    const options = chart_options_bar;
    
    //const c_label = '';
    const c_labels = [];
    dataList.map(row => c_labels.push(row.name + ' [ '+row.ManagedRisks+' | '+row.UnmanagedRisks+' ] '));
    const c_data1 = [];
    dataList.forEach(row => c_data1.push(row.ManagedRisks));
    const c_data2 = [];
    dataList.forEach(row => c_data2.push(row.UnmanagedRisks));

    const avg_data1 = [];
    dataList.forEach(row => avg_data1.push(floatFormatter(sumData.ManagedRisks,1)));
    const avg_data2 = [];
    dataList.forEach(row => avg_data2.push(floatFormatter(sumData.UnmanagedRisks,1)));
    
    const data = {
      // 각 막대별 라벨
      labels: c_labels,
      datasets: [
        {
          label: '관리위험 평균',
          type: 'line',
          data: avg_data1,
          fill: false,
          borderColor: 'rgb(255, 99, 132)',
          tension: 0.1,
          borderWidth: 1, // 테두리 두께
        },
        {
          label: '잔여위험 평균',
          type: 'line',
          data: avg_data2,
          fill: false,
          borderColor: 'rgb(54, 162, 235)',
          tension: 0.1,
          borderWidth: 1, // 테두리 두께
        },
        {
          label: '관리위험',
          type: 'bar',
          data: c_data1, // 수치
          borderWidth: 1, // 테두리 두께
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
          borderColor: 'rgb(255, 99, 132)',
        },
        {
          label: '잔여위험',
          type: 'bar',
          data: c_data2, // 수치
          borderWidth: 1, // 테두리 두께
          backgroundColor: 'rgba(54, 162, 235, 0.5)',
          borderColor: 'rgb(54, 162, 235)',
        }
      ]
    };

    return ( <Bar options={options} data={data} />);
}


/** --------------------------------------------------- */

export function Chart02({dataList}) {

  const options = chart_options_bar_y;
  
  const c_label = '';
  const c_labels = [];
  
  dataList.map(row => c_labels.push(row.risk_score));
  const c_data = [];
  dataList.forEach(row => c_data.push(row.sum));
  dataList.sort((a, b) => b - a);

  const avg_data = [];
  dataList.forEach(row => avg_data.push(row.doa));
  
  // 위험도 0은 제거 
  // c_labels.shift();
  // c_data.shift();

  const data = {
    // 각 막대별 라벨
    labels: c_labels,
    datasets: [
      {
        type: 'bar',
        label: c_label,
        axis: 'y',
        data: c_data, // 수치
        borderWidth: 1, // 테두리 두께
        backgroundColor: [
          'rgba(255, 200, 200, 0.5)',
          'rgba(255, 200, 150, 0.5)',
          'rgba(255, 230, 150, 0.5)',
          'rgba(200, 255, 255, 0.5)',
          'rgba(200, 200, 255, 0.5)',
          'rgba(230, 150, 255, 0.5)',
          'rgba(201, 203, 207, 0.5)'
        ],
        borderColor: [
          'rgb(255, 99, 132)',
          'rgb(255, 159, 64)',
          'rgb(255, 205, 86)',
          'rgb(75, 192, 192)',
          'rgb(54, 162, 235)',
          'rgb(153, 102, 255)',
          'rgb(201, 203, 207)'
        ],
      }
    ]
  };
  return (<Bar options={options} data={data} />);
}
